import React, { useState, useEffect } from "react";
import { Grid } from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import { db } from "../../context/firebase";
// components
import PageTitle from "../../components/PageTitle";
import {  getDocs, collection } from "firebase/firestore";

export default function Tables() {
  const [list, setList] = useState([]);

  var newList = [];

  const fetchList = async () => {
    const data = await getDocs(collection(db, "users"));

    data.docs.forEach((item) => {
      newList.push([
        item.data().uid,
        item.data().name,
        item.data().email,
        item.data().contactNumber,
        item.data().batch,
      ]);
    });
    setList(newList);
  };

  useEffect(() => {
    fetchList();
  });
  return (
    <>
      <PageTitle title="Student Table" />
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <MUIDataTable
            title="Student List"
            data={list}
            columns={["UID", "Name", "Email", "Phone Number", "Batch"]}
            options={{
              filterType: "dropdown",
            }}
          />
        </Grid>
      </Grid>
    </>
  );
}
